/*
  NOURION IT Notfall: ehrliche Erreichbarkeit (Kerem 15.10.2026, Minutentakt 16.10.2026). Gemeinsam fuer den Notfall
  Knopf in der Kopfzeile (snippets/nrn-notfall-knopf.liquid), die Erreichbarkeitspunkte der Startseite
  (.nrn-puls--besetzt in nrn-hero, nrn-module, nrn-leistung) und die Notfall Seite (sections/nrn-notfall.liquid).

  Besetzt ist Mo bis Fr zwischen von und bis (volle Stunden, Europe/Berlin), nicht an gesetzlichen Feiertagen in
  Hamburg (docs/04 Abschnitt 5): Neujahr, Karfreitag, Ostermontag, 1. Mai, Christi Himmelfahrt, Pfingstmontag,
  Tag der Deutschen Einheit, Reformationstag, 1. und 2. Weihnachtstag. Ostersonntag nach der Gauss Formel.

  Stand im Dokument:
    html[data-nrn-besetzt="ja|nein"]  Standardzeiten 8 bis 18 Uhr, wie der Knopf im Dock. Daran haengt das CSS des
                                      Pulses (Knopf, Punkte der Startseite). Das html Element ueberlebt Horizons
                                      Hydration: morph.js gleicht die Attribute der Handy Schublade mit dem Server
                                      Markup ab, ein Stand am Knopf dort ging verloren und der Puls lief nie.
    [data-nrn-notfall-status]         jedes Element (optional data-nrn-zeiten="8-18") erhaelt weiter data-nrn-besetzt.
  Ohne JavaScript fehlt beides; das CSS zeigt dann einen stillen Punkt und nur die Servicezeiten.

  Takt: neu bewertet zu jeder vollen Minute (Zeitgeber auf den Minutenwechsel ausgerichtet statt blind alle 60 s),
  ruht in verborgenen Tabs (visibilitychange) und laeuft beim Zurueckkommen sowie nach pageshow aus dem Back Forward
  Cache sofort nach. Wer die Seite um 17:55 oeffnet, sieht um 18:00 "nicht besetzt" statt weiter "Jetzt erreichbar".

  window.NrnNotfallZeit:
    lage(von, bis, jetzt)  { besetzt: true } oder { besetzt: false, wann: 'heute' | 'morgen' | 'tag', tag: 'Montag', ab: 8 }
    istWerktag(ms)         Werktag in Hamburg fuer einen UTC Tagesstempel
    markieren(wurzel)      markiert [data-nrn-notfall-status] unterhalb von wurzel (shopify:section:load)
    auffrischen()          bewertet alles neu (html, Elemente) und ruft die Beobachter
    beobachten(fn)         fn laeuft nach jedem Auffrischen (nrn-notfall-seite.js schreibt damit seine Statustexte
                           neu); die Rueckgabe loest die Beobachtung wieder
  Keine sichtbaren Texte hier; die Saetze stehen als Einstellungen in der Sektion.
*/
(() => {
  'use strict';

  /* Zweimal geladen (Kopf und Notfall Seite binden dieselbe Datei): nur neu bewerten, kein zweiter Takt */
  if (window.NrnNotfallZeit) {
    window.NrnNotfallZeit.auffrischen();
    return;
  }

  const TAG_MS = 86400000;
  const MINUTE_MS = 60000;
  const STANDARD_ZEITEN = '8-18';
  /* Kleiner Puffer hinter dem Minutenwechsel, damit der Zeitgeber sicher in der neuen Minute feuert */
  const PUFFER_MS = 50;

  /* Ostersonntag (gregorianisch) als UTC Zeitstempel */
  const ostern = (j) => {
    const a = j % 19;
    const b = Math.floor(j / 100);
    const c = j % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const monat = Math.floor((h + l - 7 * m + 114) / 31);
    const tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, monat - 1, tag);
  };

  const schluessel = (ms) => {
    const d = new Date(ms);
    return String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0');
  };

  const feiertagsCache = new Map();
  const feiertage = (jahr) => {
    if (!feiertagsCache.has(jahr)) {
      const os = ostern(jahr);
      feiertagsCache.set(
        jahr,
        new Set([
          '01-01', '05-01', '10-03', '10-31', '12-25', '12-26',
          schluessel(os - 2 * TAG_MS), schluessel(os + TAG_MS), schluessel(os + 39 * TAG_MS), schluessel(os + 50 * TAG_MS),
        ])
      );
    }
    return feiertagsCache.get(jahr);
  };

  const istWerktag = (ms) => {
    const d = new Date(ms);
    const wt = d.getUTCDay();
    if (wt === 0 || wt === 6) return false;
    return !feiertage(d.getUTCFullYear()).has(schluessel(ms));
  };

  let formatBerlin = null;
  let formatTag = null;

  /* Datum und Stunde in Hamburg, unabhaengig von der Zeitzone des Geraets */
  const berlin = (jetzt) => {
    if (!formatBerlin) {
      formatBerlin = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hourCycle: 'h23',
      });
    }
    const teile = formatBerlin.formatToParts(jetzt);
    const wert = (typ) => Number((teile.find((t) => t.type === typ) || {}).value || 0);
    return { tagMs: Date.UTC(wert('year'), wert('month') - 1, wert('day')), stunde: wert('hour') % 24 };
  };

  const lage = (von = 8, bis = 18, jetzt = new Date()) => {
    const b = berlin(jetzt);
    const heuteWerktag = istWerktag(b.tagMs);
    if (heuteWerktag && b.stunde >= von && b.stunde < bis) return { besetzt: true };
    if (heuteWerktag && b.stunde < von) return { besetzt: false, wann: 'heute', ab: von };
    for (let n = 1; n <= 14; n += 1) {
      const ms = b.tagMs + n * TAG_MS;
      if (!istWerktag(ms)) continue;
      if (!formatTag) formatTag = new Intl.DateTimeFormat('de-DE', { weekday: 'long', timeZone: 'UTC' });
      return { besetzt: false, wann: n === 1 ? 'morgen' : 'tag', tag: formatTag.format(new Date(ms)), ab: von };
    }
    return { besetzt: false, wann: 'tag', tag: '', ab: von };
  };

  /* "8-18" aus einem Attribut (oder dem Standard) als Stunden von und bis */
  const zeitenAus = (text) => (text || STANDARD_ZEITEN).split('-').map(Number);

  const stand = (zeitenText) => {
    const [von, bis] = zeitenAus(zeitenText);
    return lage(von, bis).besetzt ? 'ja' : 'nein';
  };

  const markierenAlle = (wurzel) => {
    if (!wurzel || !wurzel.querySelectorAll) return;
    const ziele = wurzel.matches && wurzel.matches('[data-nrn-notfall-status]') ? [wurzel] : [];
    wurzel.querySelectorAll('[data-nrn-notfall-status]').forEach((el) => ziele.push(el));
    ziele.forEach((el) => el.setAttribute('data-nrn-besetzt', stand(el.getAttribute('data-nrn-zeiten'))));
  };

  const beobachter = new Set();
  const beobachten = (fn) => {
    if (typeof fn === 'function') beobachter.add(fn);
    return () => beobachter.delete(fn);
  };

  /* Alles neu bewerten: Stand am html Element (Standardzeiten), alle markierten Elemente, dann die Beobachter */
  const auffrischen = () => {
    const html = document.documentElement;
    if (html) html.setAttribute('data-nrn-besetzt', stand(STANDARD_ZEITEN));
    markierenAlle(document);
    beobachter.forEach((fn) => {
      try {
        fn();
      } catch (e) {
        /* ein fehlerhafter Beobachter haelt weder den Takt noch die anderen auf */
      }
    });
  };

  /* Takt: ein Zeitgeber bis kurz nach dem naechsten Minutenwechsel, danach wieder einer; in verborgenen Tabs keiner */
  let uhr = 0;
  const anhalten = () => {
    if (uhr) window.clearTimeout(uhr);
    uhr = 0;
  };
  const planen = () => {
    anhalten();
    if (document.hidden) return;
    const rest = MINUTE_MS - (Date.now() % MINUTE_MS) + PUFFER_MS;
    uhr = window.setTimeout(() => {
      uhr = 0;
      auffrischen();
      planen();
    }, rest);
  };
  const weiter = () => {
    auffrischen();
    planen();
  };

  window.NrnNotfallZeit = { lage, istWerktag, markieren: markierenAlle, auffrischen, beobachten };
  weiter();

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) anhalten();
    else weiter();
  });
  /* Zurueck aus dem Back Forward Cache: die Seite kam mit altem Stand, eingefrorene Zeitgeber zaehlen nicht */
  window.addEventListener('pageshow', (e) => {
    if (e && e.persisted) weiter();
  });
  document.addEventListener('shopify:section:load', (e) => markierenAlle(e.target));
})();
